const swiper = new Swiper('.product-variations-swiper', {
  loop: false,
  centeredSlides: false,
  // slideToClickedSlide: true,
  slidesPerView: 2,
  spaceBetween: 30,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-variant-button-next",
    prevEl: ".swiper-variant-button-prev",
  },
  // breakpoints: {
  //   1920: {
  //     centeredSlides: false,
  //   },
  // },
});